const screenTypeByHint: Record<string, string> = {
  signup: 'SignUp',
  'emailotp-signin': 'emailOTP-signIn',
}

const getNationalPenConfig = (options: any): { loginHint?: string; additionalParams?: object } => {
  const navHint = options.navHint
  const screenType = options.enableGoogleOneTap
    ? 'Google'
    : screenTypeByHint[navHint?.toLowerCase()] ?? 'SignIn'

  return {
    loginHint: options.enforcedEmail,
    additionalParams: {
      screenId: Date.now(),
      screenType,
    }
  }
}

export const connectionMapping: Record<string, (options: any) => { loginHint?: string; additionalParams?: object }> = {
  'National-Pen-Customers': getNationalPenConfig,
  'National-Pen-Customers-Dev': getNationalPenConfig
}
